// @flow
import React, { Component } from 'react'
import postJson from '../../services/postJson'

type Props = {|
  checked: boolean,
  switcherComponent: any,
  activateUrl: string,
  deactivateUrl: string,
  isCompact?: boolean,
  requestParams?: Object,
  onResponse: (Object) => void
|}

type State = {|
  loading: boolean
|}

export default class AjaxStateSwitcher extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      loading: false
    }
  }

  render() {
    const SwitcherComponent = this.props.switcherComponent
    return (
      <SwitcherComponent
        checked={this.props.checked}
        loading={this.state.loading}
        isCompact={this.props.isCompact}
        onChange={(checked) => this.requestChangeState(checked)}
      />
    )
  }

  requestChangeState(checked: boolean) {
    const { requestParams, activateUrl, deactivateUrl } = this.props
    const data = requestParams || {}
    let url = checked ? activateUrl : deactivateUrl
    this.startRequest()
    postJson(url, data)
      .done((response) => this.ajaxSucceed(checked, response))
      .fail(() => {
        window.alert('Internal Server error')
      })
      .always(() => this.finishRequest())
  }

  ajaxSucceed(checked: boolean, response: Object) {
    this.props.onResponse && this.props.onResponse(response)
  }

  startRequest() {
    this.setState({ loading: true })
  }

  finishRequest() {
    this.setState({ loading: false })
  }
}
